module.exports = __webpack_public_path__ + "static/media/heart.d1c8693b.png";